import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import AddNewTask from "@/modules/tasks/components/add-task";
import { useTheme } from "@mui/material";
import { Track } from "../../types";
import { useMemo } from "react";
import { getAddTaskButtonSx } from "@/modules/tasks/components/tasks-view/get-add-button-sx";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";

const AddTrackTask = ({ track }: { track?: Track }) => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();

  const addTaskButtonSx = useMemo(
    () => getAddTaskButtonSx(theme, isMobile),
    [theme, isMobile]
  );

  const { readonly } = useReadonlyContext();

  return (
    <AddNewTask
      disabled={readonly}
      disableRipple
      disableAssignee
      disableProperty
      prefilledAssignee={
        track?.user
          ? {
              uid: track.user.uid,
              name: track.user.name,
            }
          : undefined
      }
      prefilledProperty={
        track
          ? {
              uid: track.uid,
            }
          : undefined
      }
      addTaskButtonSX={addTaskButtonSx}
    />
  );
};

export default AddTrackTask;
